module.exports = __webpack_public_path__ + "static/media/chromatic.5025e133.png";